import React from "react";
import { Checkbox, FormControlLabel, FormControl, FormHelperText } from "@mui/material";
import { useField } from "formik";

interface LabeledCheckboxProps {
  name: string;
  label?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  required?: boolean;
}

const LabeledCheckbox: React.FC<LabeledCheckboxProps> = ({
  name,
  label,
  disabled = false,
  fullWidth = false,
  required = false,
  ...props
}) => {
  const [field, meta] = useField(name);

  return (
    <FormControl
      error={meta.touched && Boolean(meta.error)}
      fullWidth={fullWidth}
      disabled={disabled}
      {...props}
    >
      <FormControlLabel
        control={
          <Checkbox
            {...field}
            checked={Boolean(field.value)}
            required={required}
            disabled={disabled}
          />
        }
        label={label || name}
      />
      {meta.touched && meta.error && (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default LabeledCheckbox;
